// @flow

import { List, Map, fromJS } from 'immutable';

export const GET_LISTS = 'aparatTV/home/GET_LISTS';
export const GET_LISTS_SUCCESS = 'aparatTV/home/GET_LISTS_SUCCESS';
export const GET_LISTS_FAIL = 'aparatTV/home/GET_LISTS_FAIL';
export const CLEAR_LISTS = 'aparatTV/home/CLEAR_LISTS';

export const GET_CATEGORIES = 'aparatTV/home/GET_CATEGORIES';
export const GET_CATEGORIES_SUCCESS = 'aparatTV/home/GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAIL = 'aparatTV/home/GET_CATEGORIES_FAIL';

const initialState = Map({
  getListsLoading: false,
  listsData: List([]),
  getListsFail: null,
  nextPageLink: null,

  getCategoriesLoading: false,
  categoriesData: List([]),
  getCategoriesFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_LISTS:
      return state.merge({
        getListsLoading: true,
        getListsFail: null,
      });
    case GET_LISTS_SUCCESS: {
      const filteredData = {
        ...action.data,
        list_data: action.data.list_data.filter((item : any) => item.output_type === 'video'),
      };
      return state.merge({
        getListsLoading: false,
        listsData: fromJS(filteredData),
        nextPageLink: action.data.nextPageLink,
        getListsFail: null,
      });
    }
    case GET_LISTS_FAIL:
      return state.merge({
        getListsLoading: false,
        getListsFail: fromJS(action.data),
        ...(action.data.status === 'no_data' ? { nextPageLink: null } : {}),
      });
    case GET_CATEGORIES:
      return state.merge({
        getCategoriesLoading: true,
        getCategoriesFail: null,
      });
    case GET_CATEGORIES_SUCCESS:
      return state.merge({
        getCategoriesLoading: false,
        categoriesData: fromJS(action.data),
        getCategoriesFail: null,
      });
    case GET_CATEGORIES_FAIL:
      return state.merge({
        getCategoriesLoading: false,
        getCategoriesFail: fromJS(action.data),
      });
    case CLEAR_LISTS:
      return state.set('listsData', List([]));
    default:
      return state;
  }
};

export const getLists = (data : any) => (dispatch : any) => dispatch({ type: GET_LISTS, data });
export const getCategories = (data : any) => (dispatch : any) => dispatch({
  type: GET_CATEGORIES,
  data,
});

export const clearLists : any = () => ({ type: CLEAR_LISTS });
